export function InboxInIcon(props: Readonly<React.SVGProps<SVGSVGElement>>): JSX.Element {
  return (
    <svg width='12' height='13' viewBox='0 0 12 13' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M3.16667 1.16667H1.83333C1.09695 1.16667 0.5 1.76362 0.5 2.5V10.5C0.5 11.2364 1.09695 11.8333 1.83333 11.8333H9.83333C10.5697 11.8333 11.1667 11.2364 11.1667 10.5V2.5C11.1667 1.76362 10.5697 1.16667 9.83333 1.16667H8.5M5.83333 0.5V5.83333M3.83333 3.83333L5.83333 5.83333L7.83333 3.83333M0.5 7.16667H2.22386C2.40067 7.16667 2.57024 7.2369 2.69526 7.36193L4.30474 8.9714C4.42976 9.09643 4.59933 9.16667 4.77614 9.16667H6.89052C7.06734 9.16667 7.2369 9.09643 7.36193 8.9714L8.9714 7.36193C9.09643 7.2369 9.266 7.16667 9.44281 7.16667H11.1667'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
